export const formatNumber = (
  value?: number | string | null,
  fallback = '0'
): string => {
  if (value === null || value === undefined) {
    return fallback;
  }
  const num =
    typeof value === 'number'
      ? value
      : Number(String(value).replace(/[^0-9.-]/g, ''));
  if (!Number.isFinite(num)) {
    return typeof value === 'string' && value.trim() ? value : fallback;
  }
  return num.toLocaleString();
};

